import { api } from './baseRtkqApi'
import {
  CreateOrderRequest,
  EnrollConfig,
  EnrollStudent,
  GuardianStudentDetail,
  MassAttendanceRecord,
  OrderStatus,
} from '../models/enrollment'

export const enrollmentApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEnrollConfig: build.query<EnrollConfig, void>({
      query: () => '/api/enroll/config',
    }),
    getMyStudents: build.query<EnrollStudent[], void>({
      query: () => '/api/enroll/me/students',
      providesTags: ['MyStudents'],
    }),
    getMyStudentDetail: build.query<GuardianStudentDetail, number>({
      query: (studentId) => `/api/enroll/me/students/${studentId}`,
    }),
    getMyStudentMassAttendance: build.query<
      MassAttendanceRecord[],
      { studentId: number; fromDate: string; toDate: string }
    >({
      query: ({ studentId, fromDate, toDate }) => ({
        url: `/api/enroll/me/students/${studentId}/mass-attendance`,
        params: { fromDate, toDate },
      }),
    }),
    createOrder: build.mutation<OrderStatus, CreateOrderRequest>({
      query: (body) => ({
        url: '/api/enroll/orders',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['MyStudents'],
    }),
    getOrderStatus: build.query<OrderStatus, string>({
      query: (code) => `/api/enroll/orders/${code}`,
    }),
  }),
})

export const {
  useGetEnrollConfigQuery,
  useGetMyStudentsQuery,
  useGetMyStudentDetailQuery,
  useLazyGetMyStudentMassAttendanceQuery,
  useCreateOrderMutation,
  useGetOrderStatusQuery,
} = enrollmentApi
